import React from "react";

class ClaimFunctionWithInput extends React.Component {
  state = { stackId: null };

  handleClick = e => {
	  var inputInt = document.getElementById(this.props.value);    
	  this.setValue(inputInt.value);
	  
  };

  setValue = (input1) => {
    const { drizzle, drizzleState } = this.props;
    const contract = drizzle.contracts.ClaimPriorityDate;

    // let drizzle know we want to call the `set` method with `value`
    const stackId = contract.methods[this.props.value].cacheSend(input1, {
      from: drizzleState.accounts[0]
    });

    // save the `stackId` for later reference
    this.setState({ stackId });
  };

  getTxStatus = () => {
    // get the transaction states from the drizzle state
    const { transactions, transactionStack } = this.props.drizzleState;

    // get the transaction hash using our saved `stackId`
    const txHash = transactionStack[this.state.stackId];

    // if transaction hash does not exist, don't display anything
    if (!txHash) return null;

    // otherwise, return the transaction status
    return `Transaction status: ${transactions[txHash] && transactions[txHash].status}`;
  };

  render() {
    return (
      <div>
		<div>
			<br/> <input type="text" id={this.props.value} /><input type="submit" value="Submit" onClick={this.handleClick}/><br/>
		</div> 
        <div>{this.getTxStatus()}</div>
      </div>
    );
  }
}

export default ClaimFunctionWithInput;